(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-brand-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-brand-code')) {
    class ProductBrandCode extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.closest('.shopify-section, dialog')?.addEventListener('variant:update', this.handleVariantUpdate, {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      handleVariantUpdate = (event) => {
        const productId = event.detail?.data?.productId;
        if (!event.detail?.data?.newProduct && productId !== this.dataset.productId) return;

        const code = this.querySelector('[data-product-code]');
        const sku = this.querySelector('[data-product-sku]');
        if (!code || !sku) return;

        const nextSku = event.detail?.resource?.sku ?? '';
        sku.textContent = nextSku;
        code.hidden = nextSku === '';
      };
    }

    customElements.define('product-brand-code', ProductBrandCode);
  }
  } catch(e) { console.error(e); }
})();

})();
